/**
 * Check if localStorage is available in the current environment. Based on MDN
 * documentation example. According to it, just testing that the property
 * exists,like in normal feature detection, may be insufficient. Various
 * browsers offer settings that disable the storage API, without hiding the global object.
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/API/Web_Storage_API/Using_the_Web_Storage_API#testing_for_availability
 */
function isLocalStorageAvailable() {
  try {
    const key = `__storage__test`;
    window.localStorage.setItem(key, '');
    window.localStorage.removeItem(key);
    return true;
  } catch (e) {
    return false;
  }
}

export default isLocalStorageAvailable;
